<template>
  <div>
    <div class="d-flex justify-content-between mt-2">
      <div class="">สินค้า</div>
      <u class="pointer" @click="$refs.modalProductList.show()">เพิ่มสินค้า</u>
    </div>
    <div>
      <div
        class="product-wrap pt-3 pb-2 pr-3 d-flex"
        v-if="productDisplayList.length > 0"
      >
        <draggable
          v-model="productDisplayList"
          @change="onSortProductList"
          class="d-flex"
        >
          <div
            v-for="(item, index) in productDisplayList"
            :key="index"
            class=""
          >
            <div class="image-card mr-2 p-2 pointer">
              <div class="text-right">
                <font-awesome-icon
                  class="icon-delete"
                  icon="times-circle"
                  color="#707070"
                  v-if="productDisplayList.length > 1"
                  @click="onDeleteProductSelected(index)"
                />
              </div>
              <div class="position-relative picture-text pic-table">
                <div
                  v-if="item.imageUrl"
                  class="square-box b-contain pic-box"
                  v-bind:style="{
                    'background-image': 'url(' + item.imageUrl + ')',
                  }"
                ></div>
              </div>
              <div class="line-clamp my-2 f-size-14">{{ item.name }}</div>
            </div>
          </div>
        </draggable>
      </div>
      <div class="no-product-wrap pt-3 pb-2 pr-3 d-flex my-2" v-else>
        <div>กรุณาเลือกสินค้า</div>
      </div>
    </div>
    <div>
      <div v-if="v && v.content.Product.$error" class="">
        <span
          class="text-error f-size-14"
          v-if="v.content.Product.required == false"
        >
          กรุณาเลือกสินค้าอย่างน้อย 1 สินค้า
        </span>
      </div>
    </div>
    <ModalProductList
      ref="modalProductList"
      :productSelectedList="response.content.Product"
      v-on:onSetSubmitProductSelected="onSetSubmitProductSelected"
    />
  </div>
</template>

<script>
import ModalProductList from "../modal/ModalProductList.vue";
import draggable from "vuedraggable";
export default {
  components: {
    ModalProductList,
    draggable,
  },
  props: {
    response: {
      required: true,
      type: Object,
    },
    v: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      productFilter: {
        Categories: [],
        pageNo: 1,
        perPage: 9,
        productIdList: [],
        searech: "",
      },
      productDisplayList: [],
    };
  },
  created: async function () {},
  mounted: async function () {
    this.$nextTick(async () => {
      if (this.response.content.Product.length > 0) {
        this.response.content.Product.sort(function (a, b) {
          return a.SortOrder - b.SortOrder;
        });

        this.productFilter.productIdList = this.response.content.Product.map(
          (el) => el.ProductId
        );
        await this.getProductSelectedList();
      }
    });
  },
  methods: {
    onSortProductList() {
      this.productDisplayList.forEach((element, index) => {
        this.response.content.Product.forEach((element2) => {
          if (element.id == element2.ProductId) {
            element2.SortOrder = index + 1;
          }
        });
      });
    },
    onDeleteProductSelected: async function (index) {
      this.response.content.Product.splice(index, 1);
      this.productFilter.productIdList = this.response.content.Product.map(
        (el) => el.ProductId
      );

      await this.getProductSelectedList();
    },
    onSetSubmitProductSelected(productSelectedList) {
      this.productFilter.productIdList = productSelectedList.map(
        (el) => el.ProductId
      );
      this.response.content.Product = productSelectedList;
      this.getProductSelectedList();
    },
    getProductSelectedList: async function () {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/product/list`, this.productFilter)
        .then((data) => {
          if (data.result == 1) {
            this.productDisplayList = data.detail.dataList;
            this.response.content.Product.forEach((element, index) => {
              this.productDisplayList.forEach((element2) => {
                if (element.ProductId == element2.id) {
                  element2.SortOrder = index;
                }
              });
            });
            this.productDisplayList.sort(function (a, b) {
              return a.SortOrder - b.SortOrder;
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-wrap {
  width: calc(100%);
  overflow: hidden;
  overflow-x: auto;
  //   background-color: white;
}
.image-card {
  width: 150px;
  background-color: white;
  min-height: 220px;
  border-radius: 8px;
}
.line-clamp {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.f-size-14 {
  font-size: 14px;
}
.text-error {
  color: red;
}
.no-product-wrap {
  background-color: white;
  min-height: 100px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  color: #bebebe;
}
</style>